import { gql } from '@apollo/client';

import { assertUnreachableOrReturnDefault } from 'src/lib/assertUnreachable';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { CheckTaskType } from '../../routes';

export const taskToTaskTypeTaskFragment = gql`
  fragment taskToTaskTypeTaskFragment on CheckWorkflowTask {
    id
  }
`;

export function taskToTaskType(
  task: GraphQLTypes.taskToTaskTypeTaskFragment,
): CheckTaskType | 'unknown' {
  switch (task.__typename) {
    case 'CompositionCheckTask':
      return 'build';
    case 'CustomCheckTask':
      return 'custom';
    case 'DownstreamCheckTask':
      return 'downstream';
    case 'FilterCheckTask':
      return 'filter';
    case 'LintCheckTask':
      return 'linter';
    case 'OperationsCheckTask':
      return 'operations';
    case 'ProposalsCheckTask':
      return 'proposals';
    default:
      return assertUnreachableOrReturnDefault(task, 'unknown');
  }
}
